export default __webpack_public_path__ + "static/media/client5.598606bf.webp";